import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

import { TextField, TextArea, UploadFile, FieldData } from 'vopay';

import { PaymentFieldDefault } from './types';

export function useElinxDetailsFields(): FieldData<PaymentFieldDefault>[] {
  const { t } = useTranslation('translations', { keyPrefix: 'UseTransactionCreationFields' });
  return useMemo(() => {
    return [
      {
        label: () => t('Fields.senderName.label'),
        fieldName: 'SenderName',
        getInputState: () => 'required',
        showField: (values) =>
          values.ProvideOrRequestPaymentInformation === 'request' &&
          (values.Contact === 'new' || values.PaymentMethod === 'new' || values.PaymentMethod === 'request'),
        serializeField: (values) => values.SenderName,
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return <TextField variant="outlineShadow" placeholder={t('Fields.senderName.placeholder')} {...fieldData} />;
        },
        validate: () => Yup.mixed().required(),
      },
      {
        label: () => t('Fields.invoiceNumber.label'),
        fieldName: 'InvoiceNumber',
        getInputState: () => 'optional',
        showField: (values) =>
          values.ProvideOrRequestPaymentInformation === 'request' &&
          (values.Contact === 'new' || values.PaymentMethod === 'new' || values.PaymentMethod === 'request'),
        serializeField: (values) => values.InvoiceNumber,
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return <TextField variant="outlineShadow" placeholder="" {...fieldData} />;
        },
      },
      {
        label: () => t('Fields.invoiceFile.label'),
        fieldName: 'InvoiceFile',
        getInputState: () => 'optional',
        showField: (values) =>
          values.ProvideOrRequestPaymentInformation === 'request' &&
          (values.Contact === 'new' || values.PaymentMethod === 'new' || values.PaymentMethod === 'request'),
        serializeField: (values) => values.InvoiceFile,
        renderField: ({ getFormikData, ctx }) => {
          const fieldData = getFormikData<string>({});
          return (
            <UploadFile
              {...fieldData}
              id={fieldData.name}
              onChangeFileName={(e: React.ChangeEvent<HTMLInputElement>) =>
                ctx.setFieldValue('InvoiceFileName', e.target.value)
              }
              valueFileName={ctx.values.InvoiceFileName}
              maxMBSize={4}
              validExtensions={['jpeg', 'png', 'pdf']}
              base64
            />
          );
        },
      },
      {
        label: () => t('Fields.recipientMessage.label'),
        fieldName: 'RecipientMessage',
        getInputState: () => 'optional',
        showField: (values) =>
          values.ProvideOrRequestPaymentInformation === 'request' &&
          (values.Contact === 'new' || values.PaymentMethod === 'new' || values.PaymentMethod === 'request'),
        serializeField: (values) => values.RecipientMessage,
        renderField: ({ getFormikData }) => {
          const fieldData = getFormikData<string>({});
          return (
            <TextArea variant="outlineShadow" placeholder={t('Fields.recipientMessage.placeholder')} {...fieldData} />
          );
        },
      },
    ];
  }, []);
}
